import { useLocation, useParams } from "react-router-dom"

import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { get_users } from "../../../api/api";
import UserNavbar from "./components/userNavbar";
import Loading from "../../Loading";

import InfiniteScroll from 'react-infinite-scroller';
import UserList from './components/UserList';


const UsersTrafic = () => {

     const [usersList, setUsersList] = useState([])
     const [loading, setLoading] = useState(false)
     const [pageNum, setPageNum] = useState(1)
     const [fetching, setFetching] = useState(false)
     const [notFound, setNotFound] = useState(false)

     const params = useParams()
     const location = useLocation()

     const getUserList = async (keyword = '', pageNum = 1) => {
          try {
               setLoading(true)
               const res = await axios.get(get_users(keyword, pageNum))
               setUsersList(res.data)

               res.data == '' && pageNum === 1 ? setNotFound(true) : setNotFound(false)

          } finally {
               setLoading(false)
          }
     }




     useEffect(() => {
          if (location.search) {
               getUserList(location.search)
          }
     }, [params])



     //loadmore
     const fetchItems = useCallback(
          async () => {
               if (fetching) {
                    return;
               }

               setFetching(true);

               try {
                    setLoading(true)
                    const res = await axios.get(get_users(location.search, pageNum))
                    setUsersList([...usersList, ...res.data])

                    res.data != '' ? setPageNum(pageNum + 1) : setPageNum(null)
                    res.data == '' && pageNum === 1 ? setNotFound(true) : setNotFound(false)

               } finally {
                    setFetching(false)
               }

          },


          [usersList, fetching, pageNum]
     );

     const hasMoreItems = !!pageNum;
     //loadmore


     return (
          <>
               <UserNavbar />

               <InfiniteScroll
                    loadMore={fetchItems}
                    hasMore={hasMoreItems}
                    loader={<Loading key={pageNum} styles={'mini'} />}
               >

                    <div className="contentHolder">
                         {usersList.map(user => <UserList user={user} key={user.userId} />)}
                    </div>


               </InfiniteScroll>

               {notFound ? (<p style={{ textAlign: 'center' }}>هیچ داده ای برای نمایش وجود ندارد!</p>) : ''}
          </>
     )
}
export default UsersTrafic